<!-- Header -->
<component-header></component-header>
<!-- content -->
<router-outlet></router-outlet>
<!-- Footer -->
<component-footer></component-footer>
